import React, { Component } from 'react';
import { Link } from 'react-router-dom';

var bgfoter = require('./../../images/background/bg2.jpg');


class Footer extends Component {

	render() {
		return (
			<footer className="site-footer " style={{ backgroundImage: "url(" + bgfoter + ")", backgroundSize: 'cover' }} >

				<div className="footer-top bg-line-top">
					<div className="container">
						<div className="row">
							<div className="col-xl-3 col-lg-6 col-md-6 col-sm-6">
								<div className="widget widget_getintuch">
									<h5 className="footer-title text-white">Contact Us</h5>
									<ul>
										<li>
											<a href='https://maps.app.goo.gl/PsWLFsJPuy3rSRWK7'><i className="fa fa-map-marker"></i>
												<p>Tiruvanchery, Tambaram</p></a>
										</li>
										<li>
											<a href='tel:+917358605115'><i className="fa fa-phone"></i>
												<p>7358605115</p></a>
										</li>
										<li><a href='mailto:cacofachocolates@gmail.com' target='blank'>
											<i className="fa fa-envelope"></i>
											<p>cacofachocolates@gmail.com</p></a>
										</li>
										<li><a href='https://www.instagram.com/cacofa_chocolates/' target='blank'>
											<i class="fa fa-instagram" aria-hidden="true"></i>
											<p>cacofa_chocolates</p></a>
										</li>

									</ul>
								</div>
							</div>
							<div className="col-xl-3 col-lg-6 col-md-6 col-sm-6">
								<div className="widget widget_services border-0">
									<h4 className="footer-title">Quick Links</h4>
									<ul className="list-2">
										<li><Link to={'/'}>Home</Link></li>
										<li><Link to={'/about-1'}>About</Link></li>
										<li><Link to={'/our-menu-1'}>Our Menu</Link></li>
										<li><Link to={'/faq'}>FAQ</Link></li>
										<li><Link to={'/contact-1'}>Contact</Link></li>
									</ul>
								</div>
							</div>
							<div className="col-xl-3 col-lg-6 col-md-6 col-sm-6">
								<div className="widget border-0">
									<h4 className="footer-title">Opening Hours</h4>
									<p className="m-b20">Our support available to help you 24 hours a day, seven days a week.</p>
									<ul className="work-hour-list">
										<li>
											<span className="day"><span>Monday to Friday</span></span>
											<span className="timing">7AM - 5PM</span>
										</li>
										<li>
											<span className="day"><span>Saturday</span></span>
											<span className="timing">10AM - 5PM</span>
										</li>
										<li>
											<span className="day"><span>Sunday</span></span>
											<span className="timing">Closed</span>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="footer-bottom">
					<div className="container">
						<div className="row">
							<div className="col-lg-6 col-md-6 text-left"> <span>Copyright © 2024 Cacofa. all rights reserved.</span> </div>
							<div className="col-lg-6 col-md-6 text-right">
								<div className="widget-link">
									<ul>
										<li><Link to={'about-1'}>About Us</Link></li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</footer>

		)

	}
}

export default Footer;